<template>
    <v-container v-if="this.zamawiajacy" class="page">
  <table>
    <thead>
    <tr><td>
  
  <div class="cointainer caption" style="margin-top: 0px; margin-bottom: 10px;">
    <div class="left-cointainer">
      <img height="50" class="mt-1" contain src="/static/img/logo-tutore-small.svg">
    </div>
    <div class="right-cointainer">
      Tutore Poland Sp. z o.o.<br>
      ul. Piotrkowska 157A, 90-440 Łódź<br>
      NIP: 7272812193
    </div>
  </div>
  
    </td></tr>
    </thead>
  <tbody>
  <tr><td>
  
  <p align="center" style="margin-top:20px;">
      <strong>UMOWA ZLECENIE numer {{ shortNrUmowy() }}</strong>
  </p>
  <p>
      Zawarta pomiędzy:
  </p>
  <p><strong>Zleceniodawcą:</strong></p>
  <p>
    <strong>Tutore Poland Sp. z o.o.</strong>, z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440 Łódź, wpisaną do
    Rejestru Przedsiębiorców Krajowego Rejestru Sądowego prowadzonego przez Sąd
    Rejonowy dla Łodzi-Śródmieścia w Łodzi, XX Wydział Krajowego Rejestru Sądowego pod
    nr KRS: 0000670834, NIP: 727-28-12-193, REGON: 366891567, reprezentowaną przez: 
  </p>
  <p style="margin-top: 55px;">
  <strong>{{zamawiajacy}}</strong>,
  </p>
  <p>a</p>

    <strong>Zleceniobiorcą:</strong>
    <br/>
    Imię i nazwisko: {{imieNazwisko}}
    <br/>
    Pesel: {{pesel}}
    <br/>
    Adres: {{zamieszkany}}
    <br/>
    <br/>
    <strong>Okres trwania umowy i okres wypowiedzenia:</strong>
    <br>
    Okres trwania umowy: <strong> {{ dataStartuUmowy() }} {{dataZakonczeniaUmowy()}}</strong>
    <br>
    Okres wypowiedzenia: <strong> {{ wypo }} </strong> 
    <br/>
    <p><strong>Wynagrodzenie:</strong></p>
    Kwota brutto:<strong> {{kwota}} PLN /godzinę</strong>
    <br>
    <br>
    <p align="center"><strong>Warunki umowy</strong></p>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 1 Przedmiot umowy</strong>
  </p>
  <p>Zleceniodawca zleca, a Zleceniobiorca podejmuje się wykonywania za wynagrodzeniem na rzecz Zleceniodawcy takich czynności jak:
  </p>
  <ol type="a">
    <li>reprezentowanie Zleceniodawcy wobec osób prywatnych, firm i instytucji, znajomość oferty i udzielanie informacji w zakresie oferowanych przez Zleceniodawcę usług i produktów,</li>
    <li>sporządzanie raportów i podsumowań z pracy własnej,</li>
    <li>prezentowanie oferty usług oferowanych przez Zleceniodawcę przed potencjalnymi klientami w szkołach i innych placówkach bądź firmach oraz przede wszystkim przed klientami indywidualnymi,</li>
    <li>działania związane ze sprzedażą i promocją usług oferowanych przez Zleceniodawcę, w tym organizowanie akcji promocyjnych, badanie rynku i konkurencji,</li>
    <li>realizacja celów budżetowych i jakościowych w projekcie wyznaczonych przez Zleceniodawcę,</li>
    <li>inne zadania zlecone przez Zleceniodawcę.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 2 Realizacja przedmiotu zlecenia</strong>
  </p>
  <ol>
  <li>Strony ustalają wspólnie, iż Zleceniobiorca zobowiązuje się wykonywać przedmiot niniejszej umowy z należytą starannością, tj. będzie:
  <ol type="a">
    <li>rzetelnie i dokładnie uzupełniać dane w udostępnionych przez Zleceniodawcę narzędziach i oprogramowaniach,</li>
    <li>przestrzegać określonych przez Zleceniodawcę wytycznych prowadzenia rozmowy z klientem,</li>
    <li>rzetelnie i dokładnie ewidencjonować godziny wykonywania zlecenia w udostępnionym zestawieniu, o którym mowa w § 5 ust.2,</li>
    <li>udzielać informacji osobie wskazanej przez Zleceniodawcę o niezakończonych zadaniach w ramach realizacji przedmiotu zlecenia w danym dniu.</li>
  </ol>
  </li>
  <li>Zleceniobiorca będzie wykonywać usługi objęte niniejszą umową w warunkach całkowitej niezależności od Zleceniodawcy. W szczególności Zleceniodawca nie będzie uprawniony do wykonywania wobec Zleceniobiorcy jakichkolwiek praw kierowniczych, nie ingerując w organizację i/lub dyscyplinę pracy Zleceniobiorcy. Wszelkie problemy techniczne lub metodologiczne dotyczące całości powierzonych Zleceniobiorcy czynności będą rozwiązywane przez wspólne porozumienie Stron, z poszanowaniem niezależności działalności zawodowej prowadzonej przez Zleceniobiorcę.</li>
  <li>Zleceniobiorca będzie wykonywał Zlecenie wg grafików obecności uprzednio ustalonych wspólnie ze Zleceniodawcą.</li>
  <li>Zleceniobiorca nie może powierzyć wykonania przedmiotu niniejszej umowy osobie trzeciej.</li>
  <li>Zleceniobiorca zobowiązuje się do dbania o należyty stan mienia Zleceniodawcy oraz o porządek i ład w miejscu wykonywania zlecenia.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 3 Obowiązek informacyjny</strong>
  </p>
    <ol>
      <li>Zleceniodawca zobowiązany jest dostarczać Zleceniobiorcy wszelkich informacji niezbędnych do realizacji przez niego przedmiotu umowy.
  </li>
      <li>Zleceniobiorca zobowiązany jest udzielać Zleceniodawcy potrzebnych informacji o przebiegu realizacji przez niego przedmiotu umowy.</li>
    </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 4 Okres wypowiedzenia</strong>
  </p>
  <ol>
    <li>Strony mogą rozwiązać Umowę z zachowaniem {{ okresWypowiedzenia() }} okresu wypowiedzenia liczonego jako dni robocze, po pisemnym przesłaniu informacji o wypowiedzeniu umowy (z zastrzeżeniem ustępu 2.).
    </li>
    <li>Zleceniodawca ma prawo rozwiązać niniejszą Umowę bez zachowania okresu wypowiedzenia jeżeli Zleceniobiorca rażąco sprzeciwia się postanowieniom niniejszej Umowy, przez co strony rozumieją w szczególności:
      <ul>
          <li>zachowanie Zleceniobiorcy polegające na niewykonywaniu obowiązków określonych w § 1 ust. 1 niniejszej Umowy, pomimo uprzedniego wezwania ze strony Zleceniodawcy do zaniechania naruszeń;</li>
          <li>złamanie przez Zleceniobiorcę zakazu konkurencji;</li>
          <li>ujawnienie przez Zleceniobiorcę Informacji Poufnych;</li>
          <li>wszelkie inne naruszenia niniejszej umowy.</li>
      </ul>
    </li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 5 Termin i sposób zapłaty wynagrodzenia</strong>
  </p>
  <ol>
    <li>Wypłata wynagrodzenia za każdy miesiąc wykonywania zlecenia następuje z dołu, do 15-tego dnia następnego miesiąca, w wysokości wynikającej ze stawki godzinowej oraz liczby godzin przepracowanych w danym miesiącu, w oparciu o zestawienie, o którym mowa w ust. 2 poniżej.</li>
    <li>Zleceniobiorca jest zobowiązany do przygotowania i przedłożenia Zleceniodawcy w formie elektronicznej zestawienia liczby godzin przepracowanych w danym miesiącu najpóźniej w pierwszym dniu roboczym następnego miesiąca. Zweryfikowane przez Zleceniodawcę zestawienie będzie stanowić podstawę do wypłaty wynagrodzenia Zleceniobiorcy.</li>
  </ol>
  <br>
  <br>

  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 6 Premia i benefity</strong>
  </p>
  <ol>
    <li>Zleceniodawca może przyznać Zleceniobiorcy premię uznaniową za wyniki osiągnięte w ramach wykonanego zlecenia. Premia jest naliczana w wysokości do 2000,00 (słownie dwa tysiące) złotych brutto za każdy miesiąc. Wysokość jest uzależniona od stopnia realizacji określonych celów indywidualnych przez Zleceniobiorcę oraz od jakości, ilości zgodnie z określonymi wytycznymi przez Zleceniodawcę.</li>
    <li>Zleceniodawca zastrzega sobie prawo do zmiany wysokości premii w zależności od zadań aktualnie realizowanych przez Zleceniobiorcę. Zadania indywidualne na kolejny miesiąc będą przedstawiane z odpowiednim wyprzedzeniem.</li>
    <li>W przypadku udzielania błędnych informacji klientom, Zleceniodawca może obniżyć ww. premie w zależności od ilości upomnień przekazywanych Zleceniobiorcy tj. w przypadku:</li>
      <br>
      <ul type="a">
        <li>pierwszego ostrzeżenia premia miesięczna zostanie obniżona o 50%,</li>
        <li>drugiego ostrzeżenia premia miesięczna zostanie obniżona o 80%,</li>
        <li>kolejnego ostrzeżenia premia miesięczna zostanie obniżona o 100%.</li>
        <br>
      </ul>
      <li>Wyliczenie i wypłata premii następuje w ciągu 15 dni od zakończenia miesięcznego okresu rozliczeniowego.</li>
      <li>Premia nie ma charakteru roszczeniowego, zaś jej przyznanie, jak i określenie jej wysokości należy do swobodnego uznania Zleceniodawcy.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 7 Klauzula poufności</strong>
  </p>
  <ol>
    <li>Strony, w związku z zawarciem niniejszej umowy zobowiązane są zapewnić należytą ochronę informacji poufnych przekazanych sobie dla potrzeb realizacji niniejszej umowy, w szczególności poprzez odebranie od podmiotów trzecich stosownych oświadczeń woli.</li>
    <li>Za poufne Strony uznają w szczególności materiały, dokumenty i informacje dotyczące kwestii:
      <br>
      <ul type="a">
        <li>finansowych,</li>
        <li>technicznych,</li>
        <li>handlowych,</li>
        <li>know – how,</li>
        <li>koncepcji,</li>
        <li>strategii,</li>
        <li>źródeł i sposobów finansowania.</li>
        <br>
      </ul>
      <p>Za poufne Strony nie uznają w szczególności materiałów, dokumentów i informacji, które:</p>
      <ul>
      <li>w dacie ich ujawnienia stanowią informacje dostępne publicznie;</li>
      <li>są już w dacie podpisania niniejszej umowy znane Stronom i wiedza ta została nabyta zgodnie z prawem, w sposób niezwiązany z realizacją przedmiotu niniejszej umowy;</li>
      <li>zostały po zawarciu niniejszej umowy pozyskane przez Stronę od podmiotów trzecich, które z kolei nie pozyskały takiej informacji bezpośrednio lub pośrednio od drugiej Strony i nie naruszyły w inny sposób jakiegokolwiek zobowiązania poufności.</li>
      </ul>
    </li>
  <li>Zleceniobiorca zobowiązuje się zachować w tajemnicy wszelkie niewymienione w ust. 2 informacje, których ujawnienie mogłoby narazić Zleceniodawcę na szkodę.</li>
  <li>W przypadku gdy Strona, zgodnie z ogólnie obowiązującymi przepisami prawa, w szczególności na wezwanie organów działających w granicach swoich uprawnień ujawni informacje poufne przekazane jej przez drugą Stronę w ramach realizacji niniejszej umowy, ograniczenia wynikające z niniejszego paragrafu nie znajdą zastosowania i działanie takie nie będzie rodziło po stronie Strony ujawniającej informacje żadnej odpowiedzialności.</li>
  <li>Strony zobowiązują się chronić opisane w niniejszym paragrafie informacje poufne w okresie realizacji niniejszej umowy, a także w okresie 36 (trzydziestu sześciu) miesięcy po jej rozwiązaniu lub wygaśnięciu.</li>
  <li>W przypadku naruszenia zobowiązań wynikających z niniejszego paragrafu Strona naruszająca zapłaci na żądanie drugiej Strony karę umowną w kwocie 20 000,00 (słownie: dwadzieścia tysięcy) złotych.</li>
  <li>Zastrzeżenie wyżej wymienionej kary umownej nie wyklucza dochodzenia odszkodowania przenoszącego w/w kary umownej.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 8 Zgoda na wykorzystanie wizerunku</strong>
  </p>
    <ol>
      <li>Zleceniobiorca wyraża zgodę na wykorzystanie swojego wizerunku na czas trwania umowy w formie zdjęcia w korespondencji mailowej wysyłanego w imieniu Zleceniodawcy. Wizerunek będzie wykorzystywany przez Zleceniodawcę w związku z wykonywaniem zleconych zadań określonych w § 1 w celu zapewnienia najwyższych standardów pracy. Zgoda na wykorzystanie wizerunku stanowi załącznik do niniejszej umowy.</li>
    <li>Zleceniobiorca zobowiązany jest do stosowania się do przepisów Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (RODO) oraz Ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (t.j. Dz. U. z 2019 r. poz. 1781 z późn. zm). Zleceniobiorca wyraża zgodę na przetwarzanie jego danych osobowych, zgodnie z klauzulą informacyjną stanowiącą załącznik do niniejszej umowy.</li>
    </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 9 Doręczenia i korespondencja, zgoda na wykorzystanie wizerunku, RODO</strong>
  </p>
  <ol>
    <li>Strony postanawiają, że o ile nie dojdzie do pisemnego powiadomienia o zmianie adresu do korespondencji wszelka korespondencja kierowana na adresy podane w oznaczeniu stron,  uważa się za doręczone najpóźniej z datą drugiego awizo.</li>
    <li>Adresy poczty elektronicznej podane są w oznaczeniu stron. Pismo wysłane drogą elektroniczną uważa się za doręczone z chwilą, gdy druga strona miała możliwość zapoznania się z nim.</li>
    <li>Zleceniobiorca wyraża zgodę na wykorzystanie swojego wizerunku, zgodnie z załącznikiem do niniejszej umowy.</li>
    <li>Zleceniobiorca zobowiązany jest do stosowania się do przepisów Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (RODO) oraz Ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (t.j. Dz. U. z 2019 r. poz. 1781 z późn. zm). Zleceniobiorca wyraża zgodę na przetwarzanie jego danych osobowych, zgodnie z klauzulą informacyjną stanowiącą załącznik do niniejszej umowy.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 10 Spory i sąd właściwy</strong>
  </p>
  <p>
   Strony oświadczają, że dołożą wszelkich starań by spory wynikłe z niniejszej umowy rozwiązać polubownie. W przypadku sporów, które nie będą mogły zostać rozwiązane polubownie w ciągu 14 (czternastu) dni od daty otrzymania przez drugą stronę pisemnego wezwania do takiego polubownego rozwiązania, zostaną one poddane pod rozstrzygnięcie sądowi właściwemu ze względu na siedzibę Zleceniodawcy.
  </p>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 11 Kompletność oraz zmiana umowy</strong>
  </p>
  <ol>
    <li>Umowa niniejsza rozwiązuje i zastępuje wszelkie inne dotychczasowe pisemne lub ustne ustalenia, porozumienia, uzgodnienia i umowy Stron w zakresie objętym jej treścią, które niniejszym tracą moc prawną.</li>
    <li>Strony oświadczają, że poza niniejszą umowa nie istnieją między nimi żadne dodatkowe ustalenia czy porozumienia dotyczące przedmiotu niniejszej umowy.</li>
    <li>Wszelkie zmiany niniejszej umowy wymagają formy pisemnej pod rygorem nieważności.</li>
    <li>Rozwiązanie niniejszej umowy wymaga formy pisemnej pod rygorem nieważności.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 12 Klauzula salwatoryjna</strong>
  </p>
  <p>
      Jeżeli którekolwiek z postanowień niniejszej umowy okaże się nieważne w całości lub w części, pozostałe postanowienia pozostają w mocy, Strony zaś zobowiązują się na wniosek którejkolwiek z nich do zastąpienia nieważnych postanowień postanowieniami, których moc prawna i skutek ekonomiczny są najbardziej zbliżone do postanowień zastępowanych.
  </p>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 13 Prawo właściwe</strong>
  </p>
  <ol>
    <li>Niniejsza umowa podlega prawu polskiemu.</li>
    <li>W sprawach nieuregulowanych niniejszą umową zastosowanie mają właściwe przepisy prawa, w szczególności przepisy Kodeksu cywilnego.</li>
  </ol>
  <br>
  
  <p align="center" style="margin-bottom: 0px;">
    <strong>§ 14 Liczba egzemplarzy umowy</strong>
  </p>
  <p>Umowa niniejsza została sporządzona w 2 (dwóch) jednobrzmiących egzemplarzach, po jednym dla każdej ze stron.</p>
  <br>
  
  <div>
    <p class="underline">Załączniki stanowiące integralną część umowy:</p>
    <ol>
      <li class="underline">Zgoda na wykorzystanie wizerunku</li>
      <li class="underline">Klauzula informacyjna RODO</li>
      <li class="underline">Oświadczenie do umowy zlecenie </li>
      <li class="underline">Upoważnienie do przetwarzania danych osobowych</li>
      <li class="underline">Ogólne zasady bhp przy pracy administracyjno-biurowej</li>
      
    </ol>
  </div>
  
  <div class="cointainer" style="margin-top: 30px;">
      <div class="left-cointainer">
          <span style="margin-left: 0%;"><b>{{ zamawiajacy }}</b></span><br>
          <br>
          <span style="margin-left: 0%;"><b>Podpis Zleceniodawcy</b></span>
      </div>
      <div class="right-cointainer">
          {{imieNazwisko}}<br>
          <span style="margin-left: 0%;">Podpis Zleceniobiorcy</span>
      </div>
  </div>
  <br><br>
  
   <div style="margin-top:5px;page-break-before: always;">
     <p><strong>Załącznik nr 1. ZGODA NA WYKORZYSTANIE WIZERUNKU</strong></p>
     <p>Niniejszym oświadczam, że udzielam Tutore Poland Sp. z o.o., z siedzibą w Łodzi przy ul. Piotrkowska 157A, 90-440, KRS 0000670834, NIP: 727-28-12-193, REGON: 366891567, (dalej: Tutore Poland) zgody, na nieodpłatne utrwalenie oraz nieograniczone czasowo i terytorialnie wielokrotne wykorzystanie i rozpowszechnianie mojego wizerunku w formie fotografii w związku z wykonywaniem umowy zlecenia w celu umieszczenia jej w firmowej stopce mailowej. Wizerunek będzie wykorzystywany wyłącznie na czas trwania umowy w formie zdjęcia w korespondencji mailowej wysyłanego w imieniu Zleceniodawcy.</p>
     <p>Jak również niniejszym oświadczam, że udzielam Tutore Poland Sp. z o.o. zgody, na nieodpłatne utrwalenie oraz nieograniczone czasowo i terytorialnie wielokrotne wykorzystanie i rozpowszechnianie mojego głosu lub wypowiedzi utrwalonych w trakcie wykonywania niniejszej umowy o świadczenie usług przy użyciu telefonów o połączeniu VoIP (Voice over Internet Protocol).</p>
     <p>Niniejsza  zgoda  obejmuje  następujące  pola  eksploatacji:  wykorzystanie,  utrwalanie, obróbkę  i  powielanie  wykonanych  zdjęć/nagrań,  obrót  egzemplarzami,  na  których  utrwalono mój wizerunek lub głos oraz na zwielokrotnianie wizerunku/głosu wszelkimi dostępnymi technikami i metodami, rozpowszechnianie   oraz   publikowanie,   w   materiałach służących   działalności Tutore Poland Sp. z o.o. w szczególności w materiałach szkoleniowych, edukacyjnych i promocyjnych w dowolnej formie.</p>
     <p>Tutore Poland Sp. z o.o. przysługuje wyłączne prawo decydowania o formie i czasie wykorzystywania mojego wizerunku, głosu, wypowiedzi w całości lub w postaci dowolnych fragmentów. Wizerunek może być użyty do różnego rodzaju form elektronicznego przetwarzania obrazu, kadrowania i kompozycji, bez obowiązku akceptacji produktu końcowego, lecz nie w formach obraźliwych lub ogólnie uznanych za nieetyczne.</p>
  
     <div style="page-break-before: always;">
    <p><strong>Załącznik nr 2. Klauzula informacyjna RODO</strong></p>
    <p>Na podstawie art. 13 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, Tutore Poland Sp. z o.o. informuje:</p>
    <p>Administratorem Danych Osobowych jest Tutore Poland Sp. z o.o. z siedzibą przy ul. Piotrkowska 157A, 90-440 Łódź, tel.  535 933 870 info@tutore.eu, dalej ADO.</p>
    <p>ADO przetwarza dane osobowe w następujących celach, na następującej podstawie i w następującym okresie:</p>
    <p>zawarcia oraz realizacji umowy cywilnoprawnej – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. b, c, f RODO) – przez okres współpracy,</p>
    <p>wyliczenia i wypłaty wynagrodzenia – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit. b RODO) – przez okres współpracy,</p>
    <p>potrąceń z wynagrodzenia – w celu realizacji obowiązków w zakresie egzekucji z wynagrodzenia wynikających z kodeksu postępowania cywilnego, ustawy o postępowaniu egzekucyjnym w administracji, ustawy o komornikach sądowych (art. 6 ust. 1 lit. c RODO) – przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa,</p>
    <p>realizacji obowiązków podatkowych – w celu realizacji obowiązków płatnika podatku dochodowego wynikających z ordynacji podatkowej, ustawy o podatku dochodowym od osób fizycznych i innych przepisów podatkowych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku kalendarzowego,</p>
    <p>realizacji obowiązków wobec ZUS – w celu realizacji obowiązków płatnika  składek  na  ubezpieczenie społeczne  i  zdrowotne wynikających z ustawy o emeryturach i rentach z Funduszu Ubezpieczeń Społecznych, ustawy o systemie ubezpieczeń społecznych oraz ustawy o świadczeniach opieki zdrowotnej finansowanych ze środków publicznych (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit b RODO) – przez okres 5 lat od końca roku kalendarzowego,</p>
    <p>realizacji obowiązków księgowych – w celu realizacji obowiązków wynikających z ustawy o rachunkowości, ordynacji podatkowej oraz ustawy o podatku dochodowym od osób prawnych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku rozliczeniowego, w którym nastąpiło zdarzenie,</p>
    <p>bezpieczeństwa fizycznego budynków, pomieszczeń oraz mienia Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) – przez okres współpracy,</p>
    <p>zapewnienia najwyższych standardów obsługi zajęć lekcyjnych realizowanych przez Współpracowników za pośrednictwem platformy ClickMeeting lub Zoom, prawidłowości wykonywania powierzonych czynności oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy) poprzez monitoring i nagrywanie kursów online – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) – Wizerunek i głos Współpracownika będzie przetwarzany przez okres 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych zajęć stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,</p>
    <p>zapewnienia możliwości udostępnienia nagrań nowym Zleceniobiorcom, Pracownikom i Współpracownikom nagrywanie szkoleń online prowadzonych za pomocą platformy Zoom – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,</p>
    <p>zapewnienia najwyższych standardów jakości obsługi klienta, w celu szkoleniowym – umożliwiającym poprawienie jakości obsługi, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), zapewnienia bezpieczeństwa Współpracownikom w przypadku zdarzeń niepożądanych i niebezpiecznych ze strony Klientów (np. groźby karalne) poprzez monitoring rozmów telefonicznych z Klientami Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) - przez okres do 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych rozmów telefonicznych stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,</p>
    <p>dochodzenia roszczeń lub obrony przed roszczeniami – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) polegającego na występowaniu w sprawach sądowych – w przypadku toczącego się postępowania przez okres trwania postępowania do czasu jego prawomocnego zakończenia oraz przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa.</p>
    <p>ADO nie przekazuje danych osobowych poza Europejski Obszar Gospodarczy.</p>
    <p>Dane osobowe przechowywane będą przez odpowiedni okres wskazany w ust. 2. Po upływie tego okresu dane osobowe przechowywane w systemach informatycznych podlegają usunięciu, a nośniki informacji przechowujące dane, podlegają zniszczeniu.</p>
    <p>Odbiorcami danych osobowych mogą być:</p>
    <p>organy administracji publicznej (np. Zakład Ubezpieczeń Społecznych, Urzędy Skarbowe) – na mocy odpowiednich przepisów prawa,</p>
    <p>zakłady opieki zdrowotnej w celach związanych z medycyną pracy,</p>
    <p>podmioty zewnętrzne dostarczające i wspierające systemy teleinformatyczne Zleceniodawcy (zarówno ogólną infrastrukturę teleinformatyczną, pocztę elektroniczną, jak i  systemy informatyczne stosowane przez Zleceniodawcę w celu obsługi kadrowo-finansowej lub obiegu dokumentów związanych z zatrudnieniem) – na mocy stosownych umów powierzenia przetwarzania danych osobowych oraz przy zapewnieniu stosowania przez ww. podmioty adekwatnych środków technicznych i organizacyjnych zapewniających ochronę danych,</p>
    <p>biura księgowe,</p>
    <p>banki – w celu wypłaty wynagrodzeń i innych świadczeń pieniężnych na rzecz Zleceniodawcy w przypadku ich wypłaty za zgodą Zleceniobiorcy na rachunek bankowy,</p>
    <p>kontrahenci – w celu umożliwienia kontrahentom (potencjalnym oraz obecnym) kontaktu lub w celu bieżącej realizacji zawartych umów, a związanych z  zajmowanym przez Zleceniobiorcę stanowiskiem pracy,</p>
    <p>współpracownicy Zleceniodawcy, którzy świadczą usługi na rzecz Tutore Poland Sp. z o.o., w celu umożliwienia współpracownikom kontaktu ze Zleceniobiorcą,</p>
    <p>podmioty świadczące dodatkowe usługi dla Zleceniobiorców, wyłącznie w przypadku korzystania przez Zleceniobiorcę z tych usług,</p>
    <p>instytucje ubezpieczeniowe,</p>
    <p>organizacje administracji zagranicznej w krajach UE, w których realizowana jest umowa (dotyczy realizacji umowy za granicą),</p>
    <p>podmioty szkoleniowe i realizujące obowiązki BHP (jeśli nie ma komórki BHP u Zleceniodawcy).</p>
    <p>Osoba której dane są przetwarzane ma prawo:</p>
    <ol type="a">
      <li>dostępu do swoich danych oraz otrzymania ich kopii,</li>
      <li>prawo do sprostowania (poprawiania) swoich danych,</li>
      <li>prawo do ograniczenia przetwarzania,</li>
      <li>prawo do bycia zapomnianym,</li>
      <li>prawo do sprzeciwu,</li>
      <li>prawo do przenoszenia danych,</li>
      <li>prawo do cofnięcia zgody na przetwarzanie,</li>
      <li>prawo do wniesienia skargi do Urzędu Ochrony Danych Osobowych.</li>
    </ol>
    <p>W ramach działalności ADO nie dochodzi do zautomatyzowanego podejmowania decyzji, w tym profilowania, z wykorzystaniem zebranych danych osobowych.</p>
  <div class="container">
      <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
        <tr>
          <td id="oswiadczenie">
            <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
            <ol>
          <li>Ja niżej podpisany/a oświadczam, iż:
          <ul>
            <li>
              zapoznałem/am się z Informacją o przetwarzaniu moich danych osobowych i przyjmuję ją do wiadomości,
            </li>
            <li>
              treść Informacji jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący.
            </li>
          </ul>
          </li>
          </ol>
            <div class="right-cointainer" style="float: right; margin-top: 20px;">
          <span style="font-size: 14px;">{{imieNazwisko}}</span>
          <br>
          <span>czytelny podpis Zleceniobiorcy</span>
          </div>
        </td>
      </tr>
    </table>
    </div>
    </div>
    </div>
  
  <div style="margin-top:40px; page-break-before: always; font-size: 10px;">
    <p align="right" style="font-size: 14px; margin-bottom: 0;">
          Łódź, dnia {{ aktualnaData() }} r.
        </p>
          <p style="font-size: 14px; margin-bottom: 0;">{{imieNazwisko}}</p>
          <p style="font-size: 14px;">Imię i nazwisko Zleceniobiorcy</p>
      <p align="center" class="subheading">
        <strong>INFORMACJA O PRZETWARZANIU DANYCH OSOBOWYCH</strong>
      </p>
  <ol>
    <li>
      Informuję, że Administratorem danych osobowych Pani/Pana jako Zleceniobiorcy jest Tutore Poland Sp. z o.o. z siedzibą przy ul. Piotrkowska 157A, 90-440 Łódź, KRS: 0000670834, NIP: 7272812193, tel. 500 965 135, info@tutore.eu
    </li>
    <li>
      Przedstawiając Pani/Panu niniejszą informację o przetwarzaniu danych osobowych Administrator spełnia obowiązek prawny wynikający z art. 15 ust. 1 Rozporządzenia Parlamentu Europejskiego i  Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w  związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO.
    </li>
    <li>
      Administrator pozyskuje informacje o Pani/Panu w związku z obowiązkiem ustawowym, co jest niezbędne do skutecznej realizacji procesu współpracy. W zakresie danych osobowych nie dotkniętych ustawowym warunkiem niezbędności – ich podanie jest dobrowolne.
    </li>
    <li>
      Pani/Pana dane osobowe przetwarzane są w następujących celach, na następującej podstawie i w następującym okresie:
      <ol type="a">
        <li>
          zawarcia oraz realizacji umowy cywilnoprawnej – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. b, c, f RODO) – przez okres współpracy,
        </li>
        <li>
          wyliczenia i wypłaty wynagrodzenia – w celu realizacji obowiązku wynikającego z kodeksu cywilnego (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit. b RODO) – przez okres współpracy,
        </li>
        <li>
          potrąceń z wynagrodzenia – w celu realizacji obowiązków w zakresie egzekucji z wynagrodzenia wynikających z kodeksu postępowania cywilnego, ustawy o postępowaniu egzekucyjnym w administracji, ustawy o komornikach sądowych (art. 6 ust. 1 lit. c RODO) – przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa,
        </li>
        <li>
          realizacji obowiązków podatkowych – w celu realizacji obowiązków płatnika podatku dochodowego wynikających z ordynacji podatkowej, ustawy o podatku dochodowym od osób fizycznych i innych przepisów podatkowych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku kalendarzowego,
        </li>
        <li>
          realizacji obowiązków wobec ZUS – w celu realizacji obowiązków płatnika  składek  na  ubezpieczenie społeczne  i  zdrowotne wynikających z ustawy o emeryturach i rentach z Funduszu Ubezpieczeń Społecznych, ustawy o systemie ubezpieczeń społecznych oraz ustawy o świadczeniach opieki zdrowotnej finansowanych ze środków publicznych (art. 6 ust. 1 lit. c, art. 9 ust. 2 lit b RODO) – przez okres 5 lat od końca roku kalendarzowego,
        </li>
        <li>
          realizacji obowiązków księgowych – w celu realizacji obowiązków wynikających z ustawy o rachunkowości, ordynacji podatkowej oraz ustawy o podatku dochodowym od osób prawnych (art. 6 ust. 1 lit. c RODO) – przez okres 5 lat od końca roku rozliczeniowego, w którym nastąpiło zdarzenie,
        </li>
        <li>
          bezpieczeństwa fizycznego budynków, pomieszczeń oraz mienia Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) – przez okres współpracy,
        </li>
        <li>
          zapewnienia najwyższych standardów obsługi zajęć lekcyjnych realizowanych przez Współpracowników za pośrednictwem platformy ClickMeeting lub Zoom, prawidłowości wykonywania powierzonych czynności oraz ewentualnego poprawienia jakości lekcji, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy) poprzez monitoring i nagrywanie kursów online – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) – Wizerunek i głos Współpracownika będzie przetwarzany przez okres 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych zajęć stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,
        </li>
        <li>
          zapewnienia możliwości udostępnienia nagrań nowym Pracownikom i Współpracownikom nagrywanie szkoleń online prowadzonych za pomocą platformy Zoom – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,
        </li>
        <li>
          zapewnienia najwyższych standardów jakości obsługi klienta, w celu szkoleniowym – umożliwiającym poprawienie jakości obsługi, zabezpieczenia interesów firmy w sytuacjach spornych z klientem (materiał dowodowy), zapewnienia bezpieczeństwa Współpracownikom w przypadku zdarzeń niepożądanych i niebezpiecznych ze strony Klientów (np. groźby karalne) poprzez monitoring rozmów telefonicznych z Klientami Administratora – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) - przez okres do 3 miesięcy. W przypadku, w którym nagrania zarejestrowanych rozmów telefonicznych stanowią dowód w postępowaniu prowadzonym na podstawie przepisów prawa lub Administrator powziął wiadomość, iż mogą one stanowić dowód w postępowaniu, termin ten ulega przedłużeniu do czasu prawomocnego zakończenia postępowania. Po upływie tych okresów nagrania zawierające dane osobowe, podlegają zniszczeniu,
        </li>
        <li>
          tworzenia fotorelacji z obozów dla dzieci i młodzieży na pendrive dla Klientów, fanpagu facebook i Witrynie internetowej www.musicandmore.pl – na podstawie dobrowolnej zgody nagrywanego (art. 6 ust. 1 lit. a RODO) - Wizerunek i głos Współpracownika będą przetwarzane do czasu wycofania zgody. W razie wycofania zgody nagrania zawierające dane osobowe, podlegają zniszczeniu,
        </li>
        <li>
          dochodzenia roszczeń lub obrony przed roszczeniami – na podstawie prawnie uzasadnionego interesu Administratora (art. 6 ust. 1 lit. f RODO) polegającego na występowaniu w sprawach sądowych – w przypadku toczącego się postępowania przez okres trwania postępowania do czasu jego prawomocnego zakończenia oraz przez okres wyznaczony przez powszechnie obowiązujące przepisy prawa.
        </li>
      </ol>
    </li>
    <li>
      Odbiorcami Pani/Pana danych osobowych będą:
      <ul>
        <li>
          organy administracji publicznej (np. Zakład Ubezpieczeń Społecznych, Urzędy Skarbowe) – na mocy odpowiednich przepisów prawa;
        </li>
        <li>
          zakłady opieki zdrowotnej w celach związanych z medycyną pracy;
        </li>
        <li>
          podmioty zewnętrzne dostarczające i wspierające systemy teleinformatyczne Zleceniodawcy (zarówno ogólną infrastrukturę teleinformatyczną, pocztę elektroniczną, jak i  systemy informatyczne stosowane przez Zleceniodawcę w celu obsługi kadrowo-finansowej lub obiegu dokumentów związanych z zatrudnieniem) – na mocy stosownych umów powierzenia przetwarzania danych osobowych oraz przy zapewnieniu stosowania przez ww. podmioty adekwatnych środków technicznych i organizacyjnych zapewniających ochronę danych,
        </li>
        <li>
          biura księgowe:
        </li>
        <li>
          banki – w celu wypłaty wynagrodzeń i innych świadczeń pieniężnych na rzecz Zleceniodawcy w przypadku ich wypłaty za zgodą Zleceniobiorcy na rachunek bankowy;
        </li>
        <li>
          kontrahenci – w celu umożliwienia kontrahentom (potencjalnym oraz obecnym) kontaktu lub w celu bieżącej realizacji zawartych umów, a związanych z  zajmowanym przez Zleceniobiorcę stanowiskiem pracy; 
        </li>
        <li>
          współpracownicy Zleceniodawcy, którzy świadczą usługi na rzecz Tutore Poland Sp. z o.o., w celu umożliwienia współpracownikom kontaktu ze Zleceniobiorcą,
        </li>
        <li>
          podmioty świadczące dodatkowe usługi dla Zleceniobiorców, wyłącznie w przypadku korzystania przez Zleceniobiorcę z tych usług.
        </li>
        <li>
          instytucje ubezpieczeniowe
        </li>
        <li>
          organizacje administracji zagranicznej w krajach UE, w których realizowana jest umowa (dotyczy realizacji umowy za granicą)
        </li>
        <li>
          podmioty szkoleniowe i realizujące obowiązki BHP (jeśli nie ma komórki BHP u Zleceniodawcy)
        </li>
      </ul>
    </li>
    <li>
      Ma Pani/Pan prawo do:
      <ol type="a">
        <li>
          <strong>dostępu do danych</strong> — uzyskania od Administratora potwierdzenia, czy przetwarzane są Pani/Pana dane osobowe. Jeżeli dane są przetwarzane, jest Pani/Pan uprawniona/y do uzyskania dostępu do nich (art. 15 RODO);
        </li>
        <li>
          <strong>otrzymania kopii danych</strong> — uzyskania kopii danych podlegających przetwarzaniu, przy czym pierwsza kopia jest bezpłatna, a za kolejne kopie właściwy Administrator może nałożyć opłatę w rozsądnej wysokości, wynikającą z kosztów administracyjnych (art. 15 ust. 3 RODO);
        </li>
        <li>
          <strong>sprostowania</strong> — żądania sprostowania danych osobowych, które są nieprawidłowe, lub uzupełnienia niekompletnych danych (art. 16 RODO);
        </li>
        <li>
          <strong>usunięcia danych</strong> — żądania usunięcia danych osobowych, jeżeli Administrator nie ma już podstawy prawnej do ich przetwarzania lub dane nie są już niezbędne do celów przetwarzania (art. 17 RODO);
        </li>
        <li>
          <strong>ograniczenia przetwarzania</strong> — żądania ograniczenia przetwarzania danych osobowych (art. 18 RODO), gdy:
          <ol type="i">
            <li>
              kwestionuje Pani/Pan prawidłowość danych osobowych — na okres pozwalający Administratorowi sprawdzić prawidłowość tych danych,
            </li>
            <li>
              przetwarzanie jest niezgodne z prawem, a sprzeciwia się Pani/Pan ich usunięciu, żądając ograniczenia ich wykorzystywania,
            </li>
            <li>
              Administrator nie potrzebuje już tych danych, ale są one Pani/Panu do ustalenia, dochodzenia lub obrony roszczeń;
            </li>
            <li>
              wniosła Pani/wniósł Pan sprzeciw wobec przetwarzania — do czasu stwierdzenia, czy prawnie uzasadnione podstawy po stronie Administratora są nadrzędne wobec podstaw Pani/Pana sprzeciwu;
            </li>
          </ol>
        </li>
        <li>
          <strong>przenoszenia danych</strong> — otrzymania w ustrukturyzowanym, powszechnie używanym formacie nadającym się do odczytu maszynowego danych osobowych Pani/Pana dotyczących dostarczonych Administratorowi, oraz żądania przesłania tych danych innemu Administratorowi, jeżeli dane są przetwarzane na podstawie Pani/Pana zgody, lub umowy z Panią/Panem zawartej oraz jeżeli dane są przetwarzane w sposób zautomatyzowany (art. 20 RODO);
        </li>
        <li>
          <strong>sprzeciwu</strong> — wniesienia sprzeciwu wobec przetwarzania danych osobowych w prawnie uzasadnionych celach Administratora, z przyczyn związanych z Pani/Pana szczególną sytuacją, w tym wobec profilowania. Administrator dokonuje oceny istnienia ważnych prawnie uzasadnionych podstaw do przetwarzania, nadrzędnych wobec Pani/Pana interesów, praw i wolności lub podstaw do ustalenia, dochodzenia lub obrony roszczeń. Jeżeli zgodnie z oceną Pani/Pana interesy będą ważniejsze od interesów Administratora, Administrator będzie zobowiązany zaprzestać przetwarzania danych w tych celach (art. 21 RODO);
        </li>
        <li>
          <strong>prawo wniesienia skargi do organu nadzorczego</strong> – Prezesa Urzędu Ochrony Danych Osobowych, gdy uzna Pani/Pan, iż przetwarzanie danych osobowych Pani/Pana dotyczących narusza przepisy. Skargi można składać w formie:
          <ul type="-">
            <li>
              pisemnej na adres: ul. Stawki 2, 00-193 Warszawa,
            </li>
            <li>
              elektronicznie za pośrednictwem platformy ePUAP.
            </li>
          </ul>
        </li>
      </ol>
    </li>
    <li>
      W trakcie przetwarzania danych osobowych nie dochodzi do wyłącznie zautomatyzowanego podejmowania decyzji ani do profilowania, o których mowa w art. 22 ust. 1 i 4 RODO, co oznacza, że żadne decyzje Pani/Pana dotyczące nie będą zapadać automatycznie oraz że nie będą tworzone żadne profile Pani/Pana dotyczące.
    </li>
    <li>
      Ma Pani/Pan obowiązek informowania Zleceniodawcy o wszelkich zmianach dotyczących Pani/Pana danych osobowych, przekazanych Zleceniodawcy zgodnie z Umową.
    </li>
  </ol>
  </div>
  
    <div class="container">
      <table style="border: 1px solid; text-align: left; font-size: 14px; width: 100%;">
        <tr>
          <td id="oswiadczenie">
            <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
          Ja niżej podpisany/a oświadczam, iż:
          <ol type="a">
            <li>zapoznałem/am się z Informacją o monitoringu rozmów telefonicznych oraz Klauzulą Informacyjną i przyjmuję ją do wiadomości,</li>
            <li>treść Informacji i Klauzuli jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący.</li>
            </ol>
            <br>
            <div class="right-cointainer" style="float: right;">
          {{ imieNazwisko }}
          <br>
          <span>czytelny podpis Zleceniobiorcy</span>
          </div>
        </td>
      </tr>
    </table>
    </div>
  
      <div style="margin-top:5px;page-break-before: always;">
    <p><em>Załącznik nr 3</em></p>
    <p align="center" class="subheading"><strong>Oświadczenie Zleceniobiorcy</strong></p>
  
    <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
    <tbody>
  
    <tr>
    <td style="border: 1px solid; background-color: #a4c2f4; text-align: center; width: 300px;">
    <p class="cell-in-first-table"><span><strong>DANE OSOBOWE</strong></span></p>
    </td>
    <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
    <p class="cell-in-first-table"><span><strong>DO WYPEŁNIENIA</strong></span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Data</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{data}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Imiona i Nazwisko</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{imieNazwisko}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Numer PESEL</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{pesel}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Seria i numer dowodu osobistego (proszę podać w przypadku braku nr PESEL)</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{nrDowodu}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Obywatelstwo</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{obywatelstwo}}</span></p>
    </td>
    </tr>

    <tr v-if="obywatelstwoA">
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>A. Posiadam na terytorium Rzeczypospolitej Polskiej centrum interesów osobistych lub gospodarczych (ośrodek interesów życiowych*):</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{obywatelstwoA}}</span></p>
    </td>
    </tr>

    <tr v-if="obywatelstwoB">
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>B. Przebywam na terytorium Rzeczypospolitej Polskiej dłużej niż 183 dni w roku kalendarzowym (podatkowym):</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{obywatelstwoB}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Numer telefonu</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{nrTelefonu}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Adres e-mail</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{email}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Adres zamieszkania</span><br><span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table bigCell"><span>{{zamieszkany}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Adres korespondencyjny</span><br><span class="caption"> (ulica, nr domu, kod pocztowy, miejscowość)</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{korespondencyjny}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Urząd Skarbowy <br>(zgodny z adresem zamieszkania)</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table bigCell"><span>{{urzadSkarbowy}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>Numer rachunku bankowego</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{nrRachunku}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
    <p class="cell-in-first-table"><span><strong>OŚWIADCZAM, ŻE:</strong></span></p>
    </td>
    <td style="border: 1px solid; background-color: #a4c2f4; text-align: center;">
    <p class="cell-in-first-table"><span><strong>ODPOWIEDZI: „TAK” lub „NIE”<br>(lub opis, jeśli jest wymagany)</strong></span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>1. Jestem emerytem</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{emeryt}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>2. Jestem rencistą</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{rencista}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>3. Posiadam orzeczenie o stopniu niepełnosprawności</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{orzeczenieNiepelnosprawnosc}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>3.1. Jeśli wpisano "TAK", proszę określić orzeczony stopień niepełnosprawności</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{stopienNiepelnosprawnosc.replace(/\s*\(.*$/, '')}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>4. Jestem uczniem/studentem do 26 roku życia (nie dotyczy studiów doktoranckich, podyplomowych):</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{student}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>5. Wnoszę o dobrowolne ubezpieczenie chorobowe (tylko w przypadku objęcia obowiązkowym ubezpieczeniem emerytalnym i rentowym):</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{chorobowe.replace(/\s*\(.*$/, '')}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>6. Jestem zatrudniony/a na umowę o pracę lub umowę zlecenie<br>(Jeśli wpisano "TAK", proszę uzupełnić poniższe dane)</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{zatrudnionyUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>6.1. Nazwa i adres pracodawcy/zleceniodawcy poza Tutore Poland Sp. z o.o. (proszę wypełnić w przypadku odpowiedzi TAK w pkt. 6):</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{nazwaUmowaPraca}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>6.2. Wynagrodzenie z tytułu umowy o pracę/umowy zlecenie w innym miejscu niż Tutore Poland Sp. z o.o. jest wyższe bądź równe krajowej płacy minimalnej.</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{wynagrodzenieUmowaPraca.replace(/\s*\(.*$/, '')}}</span></p>
    </td>
    </tr>

    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>6.3. Wnoszę o dobrowolne ubezpieczenie emerytalne i rentowe (tylko w przypadku odpowiedzi TAK w pkt. 6 i 6.2):</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{ubezpieczenieEmerytalne.replace(/\s*\(.*$/, '')}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>7. Podlegam ubezpieczeniu społecznemu z innego tytułu<br>niż umowa o pracę i/lub umowa cywilno-prawna z Tutore Poland Sp. z o.o.</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{ubezpieczenieUmowaPraca}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>7.1. W przypadku odpowiedzi: TAK, proszę określić tytuł ubezpieczenia</span></p>
    </td>
    <td style="border: 1px solid;">
    <p class="cell-in-first-table"><span>{{tytulUbezpieczenieUmowaPraca}}</span></p>
    </td>
    </tr>
  
    <tr>
    <td colspan="2" style="border: 1px solid; background-color: #a4c2f4; text-align: center; font-size: 10px">
    <p class="cell-in-first-table"><span style="font-size: 12px"><strong>
    Wypełnienie powyższego oświadczenia oznacza deklarację zgodności wypisanych danych ze stanem prawnym oraz faktycznym,oraz świadomość odpowiedzialności karnej za zeznanie nieprawdy lub zatajenie prawdy.
    <br/>
    W przypadku zmiany ww. danych w trakcie trwania umowy zlecenie, zobowiązuję się do poinformowania Zleceniodawcy w terminie 7 dni od daty zaistnienia zmiany. Wszelkie szkody wynikające ze zmiany treści oświadczeń zobowiązuje się pokryć z własnych środków.
    <br/>
    </strong></span></p>
    </td>
    </tr>
  
    </tbody>
    </table>
    </div>
  
    <div style="page-break-before: always;">
    <p align="right" style="margin-bottom: 10px; font-size: 14px;">
      Łódź, dnia {{ aktualnaData() }} r.
    </p>
  <p align="center" class="subheading" style="margin-bottom: 10px;">
    <strong>
      Upoważnienie nr 1 do umowy zlecenie<br>
      do przetwarzania danych osobowych w zbiorze w wersji<br>
      elektronicznej
    </strong>
  </p>
  <p class="p-margin">
    Na podstawie art. 29 Rozporządzenia Parlamentu Europejskiego i Rady (UE) 2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych oraz uchylenia dyrektywy 95/46/WE (ogólne rozporządzenie o ochronie danych), dalej RODO, niniejszym:
  </p>
  <p class="p-margin">
    z dniem {{ aktualnaData() }} r.
  </p>
  <p class="p-margin">
    upoważniam Pana/Panią {{ imieNazwisko }} – Zleceniobiorcę Tutore Poland Sp. z o.o.
  </p>
  <p class="p-margin">
    realizującego umowę zlecenie
  </p>
  <p class="p-margin">
    do przetwarzania danych osobowych zawartych w poniżej wymienionych zbiorach danych osobowych:
  </p>
  <p class="p-margin">
    w wersji elektronicznej:
  </p>
        <ul>
          <li>
            zbiór danych osobowych kandydatów do zatrudnienia przez Tutore Poland Sp. z o.o. – imię i nazwisko, telefon kontaktowy
          </li>
          <li>
            zbiór danych osobowych osób prowadzących zajęcia w usługach oferowanych przez Tutore Poland Sp. z o.o. – imię i nazwisko, telefon kontaktowy, dane adresowe, pozostałe dane niezbędne do przygotowania umowy. 
          </li>
          <li>
            zbiór danych osobowych osób realizujących umowy cywilnoprawne w Tutore Poland Sp. z o.o. – imię i nazwisko, telefon kontaktowy, dane adresowe, pozostałe dane niezbędne do przygotowania umowy.
          </li>
        </ul>
  <p class="p-margin">
    w zakresie wglądu, wprowadzania, modyfikacji, usuwania i archiwizacji danych osobowych objętych wyżej wymienionymi zbiorami.
  </p>
  <p class="p-margin">
    Niniejsze  upoważnienie  nie  upoważnia  do  udzielania  dalszych  upoważnień  i  wygasa  z  dniem ustania umowy zlecenia, a ponadto może być w każdym czasie zmienione lub odwołane.
  </p>
  <p>
    Zobowiązuję Pana/Panią do przetwarzania danych osobowych  zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy - Administratora Danych Osobowych. Zobowiązuję Pana/Panią do przetwarzania danych osobowych  zgodnie z udzielonym upoważnieniem, rozporządzeniem Parlamentu Europejskiego i Rady  (UE)2016/679 z 27 kwietnia 2016 r. w sprawie ochrony osób fizycznych w związku z przetwarzaniem danych osobowych i w sprawie swobodnego przepływu takich danych  oraz uchylenia dyrektywy 95/46/WE ( Dz. Urz. UE L 119, s.1) oraz przepisami ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych (Dz.U. z 2018 r. poz.1000) i obowiązującymi w Tutore Poland Sp. z o.o..wewnętrznymi regulacjami w sprawie ochrony danych osobowych.
    <br>
    Naruszenie ww. obowiązków  może skutkować  poniesieniem  odpowiedzialności karnej oraz stanowi podstawę do rozwiązania umowy zlecenie.
  </p>
  
  <div style="page-break-before: always;">
  <div class="container">
      <table style="border: 1px solid; text-align: left; font-size: 12px; width: 100%;">
        <tr>
          <td id="oswiadczenie">
            <p align="center" class="subheading"><strong>OŚWIADCZENIE ZLECENIOBIORCY</strong></p>
            <ol>
          <li>Ja niżej podpisany/a oświadczam, iż:
          <ol type="a">
            <li>
              zapoznałem/am się z treścią i zakresem upoważnienia i przyjmuję je do wiadomości,
            </li>
            <li>
              treść upoważnienia jest dla mnie zrozumiała i jasna, a wszelkie wątpliwości zostały mi wyjaśnione przez osobę upoważnioną w sposób wyczerpujący,
            </li>
            <li>
              zobowiązuję się do przetwarzania danych osobowych  zawartych w ww. zbiorach danych osobowych w zakresie i w sposób wymagany do wypełnienia obowiązków służbowych względem Zleceniodawcy,
            </li>
            <li>
              zobowiązuję się do przetwarzania danych osobowych zgodnie z udzielonym upoważnieniem, przepisami Rodo oraz wewnętrznymi procedurami obowiązującymi u Zleceniodawcy, w tym Polityką Prywatności,
            </li>
            <li>
              zobowiązuję się do zachowania w tajemnicy danych osobowych, do których mam lub będę miał dostęp w związku z wykonywaniem obowiązków na rzecz Tutore Poland Sp. z o.o. oraz zachowania w tajemnicy sposobów zabezpieczenia danych osobowych, również po odwołaniu lub zmianie upoważnienia, a także po zakończeniu trwania umowy zlecenie.
            </li>
          </ol>
          </li>
          </ol>
            <div class="right-cointainer" style="float: right; margin-top: 20px;">
          <span style="font-size: 14px;">{{imieNazwisko}}</span>
          <br>
          <span>czytelny podpis Zleceniobiorcy</span>
          </div>
        </td>
      </tr>
    </table>
    </div>
    </div>
  
    <p style="text-align: center;">data i podpis</p>
    <p style="text-align: center;">{{ aktualnaData() }} r.</p>
    <p class="subheading p-margin" style="text-align: center;">
      {{ zamawiajacy }}
    <br>
    <strong>w imieniu Administratora</strong>
  </p>
  <br>
  <p>Niniejsze upoważnienie uchylone zostało w rozwiązania umowy zlecenie.</p>
  </div>
  
  <div style="margin-top: 5px;page-break-before: always;">
  <p><em><b>Załącznik nr 5</b></em></p>
  <p class="subheading" style="margin-bottom: 0px;"><strong>OGÓLNE ZASADY BHP PRZY PRACY ADMINISTRACYJNO-BIUROWEJ</strong></p>
  <br>
  <p>Bezpieczne warunki pracy są zapewnione, gdy:</p>
  <ul>
    <li>Zapewniona jest dostatecznie duża powierzchnia stanowiska pracy (co najmniej 2m wolnej powierzchni podłogi).</li>
    <li>Jest właściwe oświetlenie (w zależności od charakteru pracy min. 300lx).</li>
    <li>Jest dostateczna wentylacja pomieszczenia (naturalna lub mechaniczna); wilgotność względna powietrza nie powinna być mniejsza niż 40%.</li>
    <li>Jest wystarczające ogrzewanie w okresie jesienno-zimowym (min. +18°C)</li>
    <li>Są dostępne i w dobrym stanie urządzenia higieniczno-sanitarne oraz dobry stan techniczny mebli, sprzętu i innych urządzeń.</li>
  </ul>
  <p>Podstawowe czynności, które należy wykonać przed rozpoczęciem pracy:</p>
  <ul>
    <li>Zaplanować  kolejność wykonywania poszczególnych czynności, przygotować potrzebne dokumenty i programy.</li>
    <li>Ustawić ekran monitora względem źródeł światła tak, aby ograniczyć olśnienie i odbicia światła.</li>
    <li>Sprawdzić stan techniczny mebli, sprzętu, urządzeń, stan oświetlenia stanowiska pracy.</li>
    <li>Zaznajomić się dokładnie z instrukcją obsługi i instrukcją bezpiecznej pracy sprzętu elektrycznego i elektronicznego używanego w trakcie wykonywania pracy (komputer, drukarka, itp.).</li>
    <li>Odpowiednio dla siebie dopasować krzesło i przygotować stanowisko pracy.</li>
  </ul>
  <p>Czynności, które należy wykonywać podczas pracy:</p>
    <ul>
    <li>Utrzymywać ład i porządek na stanowisku pracy.</li>
    <li>Zachowywać ostrożność przy używaniu urządzeń elektrycznych.</li>
  </ul>
  <p>Czynności zabronione:</p>
  <ul>
    <li>Dopuszczenia do użytkowania urządzeń osób nieupoważnionych.</li>
    <li>Otwierania osłon podczas pracy urządzeń.</li>
    <li>Używania niesprawnych bądź uszkodzonych urządzeń, względnie instalacji elektrycznej (np. zniszczona izolacja na przewodach, stłuczone wtyczki lub gniazdka, prowizorycznie połączone przewody). </li>
  </ul>
  <p>Uwagi końcowe:</p>
  <ul>
    <li>
        Przy stałej pracy przy komputerze należy:
        <ul>
            <li>łączyć przemiennie prace związana z obsługą monitora ekranowego z innymi rodzajami prac nie obciążającymi narządu wzroku i wykonywanymi  w innych pozycjach ciała – przy nieprzekraczaniu 1 godziny nieprzerwanej pracy przy obsłudze monitora ekranowego lub</li>
            <li>co najmniej 5-minutową przerwę, wliczaną do czasu pracy, po każdej godzinie pracy przy obsłudze monitora ekranowego.</li>
        </ul>
    </li>
  </ul>
  <p style="margin-top: 30px;">Oświadczam, iż zapoznałem się i akceptuję powyższa zasady bhp przy pracy administracyjno-biurowej.</p>
  <div style="margin-top: 40px; font-size: 10px;">
    <p style="font-size: 14px; margin-bottom: 0;">{{ imieNazwisko }}</p>
    <p style="font-size: 14px;">Podpis Zleceniobiorcy</p>
  </div>
</div>


  
    </td></tr>
    </tbody></table>
  
    </v-container>
  </template>
  
  <script>
  export default {
    name: 'UmowaHostessaSieciSprzedazy2023.vue',
    props: {
    },
    data () {
      return {
        zamawiajacy: '',
        imieNazwisko: '',
        zamieszkany: '',
        korespondencyjny: '',
        pesel: '',
        nrRachunku: '',
        nrDowodu: '',
        nrTelefonu: '',
        email: '',
        emeryt: '',
        rencista: '',
        orzeczenieNiepelnosprawnosc: '',
        stopienNiepelnosprawnosc: '',
        student: '',
        jedenyTytulDoUbezpieczenia: '',
        chorobowe: '',
        zatrudnionyUmowaPraca: '',
        nazwaUmowaPraca: '',
        wynagrodzenieUmowaPraca: '',
        ubezpieczenieUmowaPraca: '',
        tytulUbezpieczenieUmowaPraca: '',
        umowaDo: '',
        urzadSkarbowy: '',
        nrumowy: '',
        datapocz: '',
        datakon: '',
        kwota: '',
        wypo: '',
        shortUmowa: '',
        wypoSlownie: '',
        zdalnie: '',
        obywatelstwo: '',
        dataPodpisania: '',
        ubezpieczenieEmerytalne: '',
        obywatelstwoA: '',
        obywatelstwoB: '',
      }
    },
    created () {
      Object.entries(this.$route.query).forEach(
        ([key, value]) => { this[key] = value }
      )
    },
    methods: {
      shortNrUmowy () {
        let tab = []
        tab = this.nrumowy.split('/')
        this.shortUmowa = `${tab[0]}/${tab[1]}/${tab[2]}/HOS`
        return this.shortUmowa
      },
      okresWypowiedzenia () {
        switch (this.wypo) {
          case '5 dni roboczych':
            this.wypoSlownie = '5-dniowego'
            break
          case '7 dni roboczych':
            this.wypoSlownie = '7-dniowego'
            break
          case '14 dni roboczych':
            this.wypoSlownie = '14-dniowego'
            break
        }
        return this.wypoSlownie
      },
      dataStartuUmowy () {
          if (this.datapocz === '30-12-1899') {
            return `od dnia podpisania umowy przez obie strony`
          } else {
            return `od ${this.datapocz} r.`
          }
      },
      dataZakonczeniaUmowy () {
          if (this.datakon === '30-12-1899') {
            return `do dnia zakończenia umowy`
          } else {
            return `do ${this.datakon} r.`
          }
      },
      aktualnaData() {
        const today = new Date();
        let day = today.getDate();
        if((day+1) <= 10) {
          day = '0' + day
        }
        let month = today.getMonth()+1;
        if ((today.getMonth()+1) < 10) {
          month = '0' + month
        } 
        const todayDate = day+'-'+month+'-'+today.getFullYear()
        return todayDate
      }
    },
    mounted () {
      if (this.zamawiajacy) {
        this.$nextTick(() => {
          window.setTimeout(() => window.print(), 300)
        })
      }
    }
  }
  </script>
  
  <style scoped>
  
  .page {
    size: 210mm 297mm;
    background-size: 100% 100%;
    line-height: 1.4;
    text-align: justify;
    margin-top: 2px;
    padding-top: 0px;
  }
  
  table {
    border: 1px;
    border-collapse: collapse;
    table-layout: fixed;
  }
  
  th, td {
    border: 1px;
    border-collapse: collapse;
  }
  
  .cointainer {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  
  .cointainer-left {
    width: 20%;
  }
  
  .cointainer-right {
    width: 20%;
  }
  
  thead {
    display: table-header-group;
  }
  
  .table-border {
    border: 1px solid black;
    border-collapse: collapse;
    padding: 5px;
  }
  
  .cell-in-first-table {
    margin-top: 2px;
    margin-bottom: 2px;
    margin-left: 10px;
    margin-right: 10px;
  }
  
  ul.dashed {
    list-style-type: "- ";
    margin: 0;
  }
  
  .underline {
    text-decoration: underline;
  }
  
  .pageNum {
    position: absolute;
    right: 0px;
    font-size: 14px;
  }
  
  #oswiadczenie {
    padding: 20px;
  }
  
  .p-margin {
    margin-bottom: 5px !important;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/UmowaHostessaSieciSprzedazy2023.vue